import { AutoAwesomeOutlined } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'
import React from 'react'

interface AiAnswerBlockProps {
  children: React.ReactNode
  actions?: React.ReactNode
}

/** The AI answer itself: white, a purple edge and the sparkle mark, with the answer actions bottom right. */
export const AiAnswerBlock: React.FC<AiAnswerBlockProps> = ({ children, actions }) => (
  <Box
    data-pdf-white
    sx={{ bgcolor: 'common.white', borderLeft: 3, borderColor: 'communication.main', px: 2.5, py: 2.5 }}
  >
    <Stack direction="row" spacing={2} alignItems="flex-start">
      <AutoAwesomeOutlined sx={{ color: 'communication.dark', flexShrink: 0 }} />
      <Box flex={1} minWidth={0}>
        {children}
      </Box>
    </Stack>
    {actions && (
      <Stack direction="row" justifyContent="flex-end" spacing={0.5} mt={1.5} data-pdf-hide>
        {actions}
      </Stack>
    )}
  </Box>
)
